import classNames from 'classnames'

import { Term } from "../../utils/interfaces";
import styles from "./ListSorter.module.css"

import ListCard from "./ListCard"
import { sortBy } from 'lodash';

type CardProps = {
  index: number;
  item: Term;
  maxItems: number;
  onToggle: (item: Term) => void;
}
type ListSorterProps = {
  items: Array<Term>;
  maxItems: number;
  onToggle: (item: Term) => void;
};

function Card({ index, item, maxItems, onToggle }: CardProps) {
  const handleClick = () => onToggle(item)

  return (
    <ListCard key={item.id} onClick={handleClick} selected={item.selected}>
      <h3>{item.term}</h3>
      <p>{item.definition}</p>
    </ListCard>
  )
}

export default function ListSorter({ items, maxItems, onToggle }: ListSorterProps) {
  const sortedItems = sortBy(items, ['term'])
  return (
    <div className={styles.container}>
      <div className={styles.listContainer}>
        {sortedItems.map((item, index) => <Card key={item.id} index={index} item={item} maxItems={maxItems} onToggle={onToggle} />)}
      </div>
    </div>
  )
}
